'use strict';

export default angular.module('contartemx.proveedores', [
    'ui.router'
])
    .config(($stateProvider) => {

        $stateProvider.state('proveedores', {
            url: '/Proveedores',
            abstract: true,
            views:
            {
                'submenu': {
                    template: require('../../../../app/views/Proveedores/Proveedores_submenu.html'),
                    controller: 'ProveedoresCtrl'
                },
                '': {
                    template: require('../../../../app/views/MainContainer.html'),
                    controller: 'ProveedoresCtrl'
                }
            },
            resolve: {
                authorize: ['authorization', authorization => authorization.authorize()],
                contartemxProveedores: ($q, $ocLazyLoad) => {
                    return import(
                  /* webpackChunkName: "proveedores" */
                  './proveedores'
                  ).then(module => $ocLazyLoad.inject(module.default));
            }
              },
          data: { roles: ['Proveedores'] }
        })
    .state('proveedores.compras_gastos', {
        url: '/ComprasGastos',
        views:
        {
            'main': {
                template: require('../../../../app/views/Proveedores/ComprasGastos/ComprasGastos_main.html'),
                controller: 'ProvComprasGastosCtrl'
            }
        },
        data: { roles: ['Proveedores_ComprasYGastos'] }
    })
    .state('proveedores.compras_gastos.nuevo_gasto', {
        url: '/NuevoGasto?cveProveedor',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/ComprasGastos/NuevoGasto/NuevoGasto_main.html'),
                controller: 'provNuevoGastoCtrl'
            }
        },
        data: { roles: ['Proveedores_NotasDeGasto'] }
    })
    .state('proveedores.compras_gastos.editar_gasto', {
        url: '/EditarGasto/:cveGasto',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/ComprasGastos/EditarGasto/EditarGasto_main.html'),
                controller: 'provEditarGastoCtrl'
            }
        },
        data: { roles: ['Proveedores_NotasDeGasto'] }
    })
    .state('proveedores.compras_gastos.ver_gasto', {
        url: '/Gasto/:num_gasto',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/ComprasGastos/Gasto/Gasto_main.html'),
                controller: 'ProvGastoCtrl'
            }
        },
        data: { roles: ['Proveedores_ComprasYGastos'] }
    })
    .state('proveedores.pagos', {
        url: '/Pagos',
        abstract: true,
        views: {
            'main': {
                template: require('../../../../app/views/Proveedores/Pagos/Pagos_main.html'),
                controller: 'ProvPagosCtrl'
            }
        },
        data: { roles: ['Proveedores_Pagos'] }
    })
    .state('proveedores.pagos.cronologia', {
        url: '/Lista',
        template: require('../../../../app/views/Proveedores/Pagos/Pagos_lista.html'),
        controller: 'ProvPagosListaCtrl',
        data: { roles: ['Proveedores_Pagos'] }
    })
    .state('proveedores.pagos.complementos_pago', {
        url: '/ComplementosPago',
        template: require('../../../../app/views/ComplementosPago/ComplementosPago.html'),
        controller: 'ComplementosPagoCtrl',
        data: { roles: ['Proveedores_Pagos'] }
    })
    .state('proveedores.pagos.multiples', {
        url: '/PagosMultiples',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Pagos/PagosMultiples.html'),
                controller: 'pagosMultiplesCtrl'
            }
        },
        data: { roles: ['Proveedores_Pagos'] }
    })
    .state('proveedores.pagos.nuevo_pago', {
        url: '/Nuevo/:cveTrans',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Pagos/Nuevo_Pago/NuevoPago_main.html'),
                controller: 'ProvNuevoPagoCtrl'
            }
        },
        data: { roles: ['Proveedores_Pagos'] }
    })
    .state('proveedores.directorio', {
        url: '/Directorio',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Directorio/Directorio_main.html'),
                controller: 'ProvDirectorioCtrl'
            }
        },
        data: { roles: ['Proveedores_Directorio'] }
    })
    .state('proveedores.articulos', {
        url: '/Articulos',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Articulos/Articulos_main.html'),
                controller: 'ProvArticulosCtrl'
            }
        },
        data: { roles: ['Proveedores_Articulos'] }
    })
    .state('proveedores.Gpp', {
        url: '/Gpp',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Gpp/Gpp_main.html'),
                controller: 'ProvGppCtrl'
            }
        },
        data: { roles: ['Proveedores_Articulos'] }
    })
    .state('proveedores.articulos.perfil_articulo', {
        url: '/:cveCuentaArticulo',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Articulos/PerfilArticulo_main.html'),
                controller: 'ProvPerfilArticuloCtrl'
            }
        },
        data: { roles: ['Proveedores_Articulos'] }
    })
    .state('proveedores.directorio.perfil_proveedor', {
        url: '/:cveProveedor',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Directorio/PerfilProveedor_main.html'),
                controller: 'ProvPerfilProveedorCtrl'
            }
        },
        data: { roles: ['Proveedores_Directorio'] }
    })
    .state('proveedores.recurrentes', {
        url: '/Recurrentes',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Recurrentes/Recurrentes_main.html'),
                controller: 'ProvRecurrentesCtrl'
            }
        },
    })
    .state('proveedores.recurrentes.nuevo', {
        url: '/Nuevo/:type?cveCliente',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Recurrentes/NuevoRecurrente/Nueva_Recurrente.html'),
                controller: 'ProvNuevaRecurrenteCtrl'
            }
        }
    })
    .state('proveedores.recurrentes.ver_venta', {
        url: '/Venta/:num_venta',
        views:
        {
            'main@proveedores': {
                template: require('../../../../app/views/Proveedores/Recurrentes/VerRecurrente/Ver_Recurrente.html'),
                controller: 'ProvVerRecurrenteCtrl'
            }
        }
    });
})
.controller('ProveedoresCtrl', ($scope, $state) => {

});

